import styled, { css } from "styled-components";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import FlexItemOrg from "../../organisms/FlexItemOrg";
export var TableBar = styled(FlexContainerOrg).withConfig({
  componentId: "sc-dfkcu3-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["border-radius:", ";background-color:", ";"], getBorderRadius(theme, "mlarge"), getColor(theme, "background"));
});
export var TableBarItem = styled(FlexItemOrg).withConfig({
  componentId: "sc-dfkcu3-1"
})(function (_ref2) {
  var $isSortable = _ref2.$isSortable,
    $isSorted = _ref2.$isSorted,
    $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["padding:", " ", " ", " ", ";border-radius:", ";&:first-child{padding-left:", ";}&:last-child{padding-right:", ";}", " ", " ", ""], space(1), space(1), space(1), space(3), getBorderRadius(theme, "mlarge"), space(6), space(3), $isSortable ? css(["cursor:pointer;"]) : null, $isSortable && !$isSorted ? css(["&:hover{background-color:", ";}"], getColor(theme, "backgroundDarkLight")) : null, $isSortable && $isSorted ? css(["border:", " solid ", ";background-color:", ";box-shadow:", ";"], unit(1), getBorderColor(theme, $onColor, "extraLow"), getColor(theme, "backgroundLight"), getBoxShadow(theme, "tiny")) : null);
});